// src/components/GameHub.tsx
import React, { useState } from "react";
import SuikaGame from "../suikaGame";
import Tile2048 from "../2048";
import './Gamehub.css'

type View = "menu" | "suika" | "tile";

const GameHub: React.FC = () => {
    const [view, setView] = useState<View>("menu");

    if (view === "suika") {
        return (
            <main className="hub-wrap">

                <SuikaGame />
            </main>
        );
    }

    if (view === "tile") {
        return (
            <main className="hub-wrap">
                <Tile2048 />
            </main>
        );
    }

    // 메인 메뉴
    return (
        <main className="hub-wrap">
            <header className="hub-header">
                <div className="hub-brand">
                    <div className="hub-logo" aria-hidden>⚪</div>
                    <div>
                        <h1 className="hub-title">이도도자기 미니게임!</h1>
                        <p className="hub-sub">원하는 게임을 선택하세요</p>
                    </div>
                </div>
            </header>

            <section className="hub-grid">
                {/* 달항아리 키우기 */}
                <article className="hub-card">
                    <header className="hub-card__header">
                        <div className="hub-icon jar" aria-hidden>⚱️</div>
                        <div>
                            <h2 className="hub-card__title">달항아리 키우기</h2>
                            <p className="hub-card__desc">합치고 키워 최고 점수에 도전!</p>
                        </div>
                    </header>
                    <div className="hub-card__body">
                        <ul className="hub-meta">
                        </ul>
                    </div>
                    <footer className="hub-card__footer">
                        <button className="hub-btn" onClick={() => setView("suika")}>
                            시작하기
                        </button>
                    </footer>
                </article>

                {/* 커스텀 타일 */}
                <article className="hub-card">
                    <header className="hub-card__header">
                        <div className="hub-icon tile" aria-hidden>🧩</div>
                        <div>
                            <h2 className="hub-card__title">커스텀 타일</h2>
                            <p className="hub-card__desc">패턴 조합으로 벽을 채워보세요</p>
                        </div>
                    </header>
                    <div className="hub-card__body">
                        <ul className="hub-meta">
                        </ul>
                    </div>
                    <footer className="hub-card__footer">
                        <button className="hub-btn outline" onClick={() => setView("tile")}>
                            체험하기
                        </button>
                    </footer>
                </article>
            </section>
        </main>
    );
};

export default GameHub;
